import React from 'react';
import { Section, SectionTitle, VerticalContactContainer } from '../styles';
import ContactInfo from './ContactInfo';

type OfficeDetailsProps = {
  userAddress: any;
  orgName: string;
  officeOids?: string[];
};

const LABEL_WIDTH = '115px';

const styles = {
  label: { width: LABEL_WIDTH, color: 'grey' },
  addressText: { color: 'grey' },
};

const OfficeDetails: React.FC<OfficeDetailsProps> = ({
  userAddress,
  orgName,
  officeOids,
}) => (
  <Section data-cy="office-details-section">
    <VerticalContactContainer>
      <SectionTitle>Office Details</SectionTitle>
      <ContactInfo
        type="address"
        label="Office"
        address={{ ...userAddress, orgName }}
        styles={styles}
        includeAddressName
        includeOfficeName
      />
      <ContactInfo type="id" data={officeOids?.join(', ')} styles={styles} />
      <ContactInfo
        type="office"
        label="Office Phone"
        data={userAddress.phone}
        styles={styles}
      />
    </VerticalContactContainer>
  </Section>
);

export default OfficeDetails;
